"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const styles_2 = require("../styles");
const Text_1 = __importDefault(require("./Text"));
const ToggleButtonItem = ({ _color = 'secondary', _selected, _onPress, length = 0, label, index, }) => {
    const isStart = index === 0;
    const isEnd = index === length - 1;
    const isSelected = _selected === label;
    return (react_1.default.createElement(react_native_1.Pressable, { key: index, onPress: () => _onPress && _onPress(label), style: [
            styles.button,
            isStart && styles.start,
            isEnd && styles.end,
            isSelected && styles.selected,
            isSelected && styles[_color],
        ] },
        react_1.default.createElement(Text_1.default, { color: isSelected ? _color : 'description', margin: "none" }, label)));
};
const handleItems = (items, color, selected, onPress) => {
    return items.map((item, i) => (react_1.default.createElement(ToggleButtonItem, { label: item.props.label, _onPress: onPress, _selected: selected, key: i, _color: color, index: i, length: items.length })));
};
const ToggleButton = ({ children, color, selected, onPress, }) => {
    return react_1.default.createElement(react_native_1.View, { style: styles.container }, handleItems(children, color, selected, onPress));
};
ToggleButton.Item = ToggleButtonItem;
exports.default = ToggleButton;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        marginBottom: styles_2.getSpacing(),
    },
    button: {
        alignItems: 'center',
        backgroundColor: styles_1.Colors.lightgrey,
        borderColor: styles_1.Colors.border,
        borderWidth: 1,
        flex: 1,
        height: 40,
        justifyContent: 'center',
        marginRight: -styles_2.getSpacing(),
    },
    start: {
        borderTopStartRadius: styles_2.getRadius(),
        borderBottomStartRadius: styles_2.getRadius(),
    },
    end: {
        marginRight: 0,
        borderTopEndRadius: styles_2.getRadius(),
        borderBottomEndRadius: styles_2.getRadius(),
    },
    selected: {
        backgroundColor: styles_1.Colors.card,
        borderColor: styles_1.Colors.secondary,
        borderRadius: styles_2.getRadius(),
        zIndex: 10,
    },
    primary: {
        borderColor: styles_1.Colors.primary,
    },
    secondary: {
        borderColor: styles_1.Colors.secondary,
    },
});
